import { render } from "./main.vue?vue&type=template&id=71691bdc&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"

import "./main.vue?vue&type=style&index=0&id=71691bdc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sebamoh\\WebstormProjects\\qrscanner\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71691bdc"]])

export default __exports__